import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _get from "lodash/fp/get";
import _propEq from "lodash/fp/propEq";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { Fragment } from 'react';
import { useComponents } from 'docz';
import { MDXProvider } from '@mdx-js/react';
import { useDbQuery } from '../hooks/useDbQuery';
import Wrapper from '../wrapper';
import Theme from '../index';
import SEO from './Seo';
import { jsx as ___EmotionJSX } from "@emotion/core";

var Route = function Route(_ref) {
  var children = _ref.children,
      entry = _ref.entry,
      isTransclusion = _ref.isTransclusion,
      defaultProps = _objectWithoutPropertiesLoose(_ref, ["children", "entry", "isTransclusion"]);

  var components = useComponents();
  var NotFound = components.notFound;
  var Layout = components.layout;

  var props = _objectSpread(_objectSpread({}, defaultProps), {}, {
    doc: entry
  });

  if (!entry && !isTransclusion) return ___EmotionJSX(NotFound, null);
  return isTransclusion ? children : ___EmotionJSX(MDXProvider, {
    components: components
  }, ___EmotionJSX(Wrapper, null, ___EmotionJSX(Layout, props, children)));
};

var findEntry = function findEntry(db, ctx) {
  var isIndex = ctx && ctx.frontmatter && ctx.frontmatter.route === '/';

  var eqIndex = _propEq('value.route', '/');

  if (ctx && !ctx.entry && isIndex) return db.entries.find(eqIndex);

  var filepath = _get('entry.filepath', ctx);

  return db.entries.find(_propEq('value.filepath', filepath));
};

var includesTransclusion = function includesTransclusion(db, props) {
  var entries = db.entries;

  var filepath = _get('_frontmatter.__filemeta.filename', props);

  return !props.pageContext && entries.includes(entries.find(_propEq('value.filepath', filepath)));
};

var Layout = function Layout(_ref2) {
  var children = _ref2.children,
      defaultProps = _objectWithoutPropertiesLoose(_ref2, ["children"]);

  var ctx = defaultProps.pageContext;
  var db = useDbQuery();
  var entry = findEntry(db, ctx);
  var isTransclusion = includesTransclusion(db, defaultProps);
  return ___EmotionJSX(Fragment, null, entry && ___EmotionJSX(SEO, {
    title: entry.value.name
  }), ___EmotionJSX(Theme, {
    db: db,
    currentEntry: entry
  }, ___EmotionJSX(Route, _extends({}, defaultProps, {
    entry: entry,
    isTransclusion: isTransclusion
  }), children)));
};

export default Layout;

if (typeof Layout !== 'undefined' && Layout && Layout === Object(Layout) && Object.isExtensible(Layout) && !Layout.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Layout, '__filemeta', {
    configurable: true,
    value: {
      name: "Layout",
      filename: "node_modules/gatsby-theme-docz/src/base/Layout.js"
    }
  });
}